import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { ButtonPrimitive } from '../../button-primitive/button-primitive.js';
import { Paint, hostClassName } from '../swatch-paint.js';
import { interactive } from './swatch-button.css.js';

/** An accessible button whose visual content is a swatch. */
const SwatchButton = forwardRef(({ fill, size = 'md', shape = 'square', padding = true, ...props }, ref) => {
    return (jsx(ButtonPrimitive, { "data-fpl-component": "", ...props, ref: ref, className: clsx(hostClassName(size, shape, padding), interactive), "data-swatch-root": "", children: jsx(Paint, { fill: fill }) }));
});
SwatchButton.displayName = 'SwatchButton';

export { SwatchButton };
//# sourceMappingURL=swatch-button.js.map
